exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".income-distribution-table-container[data-v-e6f9bbd2],.income-distribution-table-container>*[data-v-e6f9bbd2]{width:100%}", ""]);

// exports
